export default __webpack_public_path__ + "fonts/d7d38ee661873900480cb6a210b6c5ef.svg";